import { Button, Form, Input, Select, InputNumber } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_API_URL } from "../../../utils/consts";
import SettingsHeader from "../Components/SettingsHeader/SettingsHeader";

const { Option } = Select;

type Props = {};
const OvertimeDetails: React.FC<Props> = () => {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm(); // Create a form instance using Form.useForm()
  const [overtimeDetails, setOvertimeDetails] = useState<any>(undefined);
  const userData = useSelector((state: any) => state.userData.user);

  useEffect(() => {
    if (userData?.clientId && params.id !== "new") {
      axios
        .get(
          `${BASE_API_URL}/admin/${userData?.clientId}/overtime/${params.id}`
        )
        .then((res) => {
          setOvertimeDetails(res.data);
        })
        .catch((err: any) => console.error(err));
    }
  }, [userData, params.id]);

  useEffect(() => {
    // Set form initial values when activeNotes changes
    if (overtimeDetails) {
      form.setFieldsValue({
        overtimeName: overtimeDetails?.overtimeName,
        deadline: overtimeDetails?.deadline,
        pay_multiplier: overtimeDetails?.pay_multiplier,
        hourly_rate: overtimeDetails?.hourly_rate,
        //   type: workingPatternDetails.type,
      });
      // setHoursSetup(workingPatternDetails.weekdays);
    } else {
      // Reset form fields if activeNotes is null or undefined
      form.resetFields();
    }
  }, [overtimeDetails, form]);

  const onFinish = async (values: any) => {
    console.log("values", values);
    if (params.id !== "new") {
      axios
        .put(`${BASE_API_URL}/admin/${params.id}/overtimeType_update`, {
          overtimeName: values.overtimeName,
          deadline: values.deadline,
          pay_multiplier: values.pay_multiplier,
          hourly_rate: values.hourly_rate,
          clientId: userData.clientId,
        })
        .then((res) => {
          console.log("res", res);
          navigate("/settings?tab=Overtimes");
        })
        .catch((error) => console.error(error));
    } else {
      axios
        .post(`${BASE_API_URL}/admin/create/overtimeType`, {
          overtimeName: values.overtimeName,
          deadline: values.deadline,
          color: "red",
          pay_multiplier: values.pay_multiplier,
          hourly_rate: values.hourly_rate,
          clientId: userData.clientId,
        })
        .then((res) => {
          console.log("res", res);
          navigate("/settings?tab=Overtimes");
        })
        .catch((error) => console.error(error));
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <>
      <div>
        <SettingsHeader
          title={
            !overtimeDetails ? t("New overtime type") : t("Edit overtime type")
          }
          onBack={() => navigate(-1)}
        />
        <div className="settingsForm">
          <Form
            name="basic"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label={t("Overtime name")}
              name="overtimeName"
              rules={[
                { required: true, message: t("Please enter overtime name") },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={t("Deadline")}
              name="deadline"
              rules={[
                { required: true, message: t("Please enter deadline") },
                //   {
                //     type: "string",
                //     min: 1,
                //     message: t("Deadline must be a positive number"),
                //   },
              ]}
            >
              <Input style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label={t("Multiplier")}
              name="pay_multiplier"
              rules={[
                { required: true, message: t("Please enter multiplier") },
                {
                  type: "number",
                  min: 1,
                  message: t("Multiplier must be a positive number"),
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label={t("Hourly Rate")}
              name="hourly_rate"
              rules={[
                { required: true, message: t("Please enter hourly rate") },
              ]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>

            <div className="saveWorkingPattern">
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  {t("Save")}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default OvertimeDetails;
